import styled from "styled-components";
import { colors } from "../../../../shared/styled/varibles";

export const PortalSC = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${colors.white};
    display: flex;
    box-shadow: 0px 4px 23px 3px rgba(0, 0, 0, 0.09);
    border-radius: 1.6rem;
    padding: 3.6rem 5.5rem 3.6rem 3.6rem;
    z-index: 1000;
`;

export const CloseSC = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 3.6rem;
    height: 3.6rem;
    font-size: 3.6rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
    z-index: 10;
    color: ${colors.stroke};
    border: none;
    outline: none;
    background: none;
`;

export const ContentSC = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    gap: 2.2rem;
`;

export const ContextWrapperSC = styled.div`
    flex: 1;
    width: calc(30% - 2.2rem);
`;

export const VideoWrapperSC = styled.div`
    flex: 1;
    width: 70%;
`;
